import { forwardRef } from "react";
import { SvgName, cn } from "../..";
import { Button, ButtonProps } from "./Button";

export interface SvgButtonProps extends ButtonProps {
  name: SvgName;
  alt: string;
  className?: string;
  svgClassName?: string;
  isColored?: boolean;
  label?: string;
}

export const SvgButton = forwardRef<HTMLButtonElement, SvgButtonProps>(
  (
    {
      name,
      alt,
      className,
      svgClassName,
      isColored = false,
      label,
      variant = "transparent",
      ...props
    },
    ref
  ) => {
    return (
      <Button
        size="icon"
        variant={variant}
        className={cn(
          "flex w-fit items-center",
          { "px-2": label, "gap-2": label },
          className
        )}
        aria-label={alt}
        ref={ref}
        {...props}
      >
        <img
          src={
            isColored
              ? `/images/svg/svg_colors/${name}.svg`
              : `/images/svg/${name}.svg`
          }
          alt={alt}
          className={svgClassName}
        />
        {label && <p>{label}</p>}
      </Button>
    );
  }
);
SvgButton.displayName = "SvgButton";

export default SvgButton;
